// Employee chunks

const Profile = () =>
  import(
    /* webpackChunkName: "employee" */
    "@/views/Candidate/Profile/index"
  );

const employeeRoutes = [
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      auth: "candidate",
      title: "Profile",
    },
  },
];

export default employeeRoutes;
